import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'

import { CustomButton } from 'components'
import { FileManager } from 'components/FileManager'
import { useCadaverService } from 'hooks/useCadaverService'
import useStyles from './FormArquivos.styles'

export const FormArquivos = (props) => {
  const { form, idCadaver, formConclusao } = props
  const cadaverService = useCadaverService()
  const classes = useStyles()
  const [processandoDownload, setProcessandoDownload] = useState(false)

  // Sincronização inteligente com verificação de igualdade superficial para quebrar loop infinito de re-renderização
  const setArquivos = useCallback((arquivos) => {
    form.setFormState((prev) => {
      const currentArquivos = prev.values.arquivos || []
      const isIdentical =
        arquivos.length === currentArquivos.length &&
        arquivos.every((val, idx) => val === currentArquivos[idx])

      if (isIdentical) {
        return prev
      }
      return {
        ...prev,
        values: { ...prev.values, arquivos },
      }
    })
  }, [])

  const handleDownloadTermo = useCallback(() => {
    const values = {
      ...form.formState.values,
      ...formConclusao.formState.values,
    }
    cadaverService.downloadTermoEntrega(idCadaver, values, setProcessandoDownload)
  }, [idCadaver, form.formState.values, formConclusao.formState.values])

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.headerAcoes}>
          <CustomButton
            variant="contained"
            colorType="primary"
            startIcon={<CloudDownloadIcon />}
            onClick={handleDownloadTermo}
            disabled={processandoDownload}
            isLoading={processandoDownload}
          >
            Download Termo de Entrega
          </CustomButton>
        </Grid>
        <Grid item xs={12} className={classes.item}>
          <FileManager
            rotaUpload="/arquivo/recebedorcadaver"
            rotaLoadImagem="/arquivo/recebedorcadaver"
            setArquivosPai={setArquivos}
            arquivosIniciais={[]}
            tipos={['image', 'pdf']}
          />
        </Grid>
      </Grid>
    </div>
  )
}

FormArquivos.propTypes = {
  form: PropTypes.object.isRequired,
  idCadaver: PropTypes.number.isRequired,
  formConclusao: PropTypes.object.isRequired,
}
